import { defineMessages } from 'react-intl';

export default defineMessages({
  clearFiltersButton: {
    id: 'frontbucket.jiraTab.clearFilters.text',
    description:
      'Label for a button which can be clicked to clear filters applied to the Jira issues table',
    defaultMessage: 'Clear filters',
  },
});
